import { type Theme } from '@mui/material'
import { styled } from '@mui/material'
import TextField from '@mui/material/TextField'

interface SearchBarProps {
  theme?: Theme
  fillContainer?: boolean
  isMobile?: boolean
}

export const SearchBar = styled(TextField)<SearchBarProps>(({ theme, fillContainer, isMobile }) => ({
  width: fillContainer ? '100%' : (isMobile ? '100%' : theme.spacing(80)),
  maxWidth: (fillContainer ? '100%' : (isMobile ? '100%' : theme.spacing(80))),
  transition: '.4s',
  cursor: 'pointer',
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.spacing(2),
    height: theme.spacing(10),
    paddingLeft: theme.spacing(3),
    paddingRight: '0px !important'
  },
  '& .MuiInputBase-input ': {
    paddingLeft: 0
  }
}))
